/**
 * Created by Administrador on 28/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('exchangeRateService',exchangeRateService);

    exchangeRateService.$inject = ['$http', 'CONFIG','messageService','$state'];

    function exchangeRateService($http, CONFIG, messageService,$state){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/exchangeRates';

        var service = {
            getExchangeRateByCurrencyExchangeRate: getExchangeRateByCurrencyExchangeRate,
            updateExchangeRate: updateExchangeRate,
        };

        return service;

        function getExchangeRateByCurrencyExchangeRate(id){
            return $http.get(urlBase+"/"+id+"/byCurrencyExchangeRate")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.exchangeRates : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function updateExchangeRate(exchangeRate, id){
            return $http.put(urlBase + "/" + id, exchangeRate)
                .then(function(){
                    messageService.registerUpdate('currencyExchangeRates');
                    $state.go('currencyExchangeRates', null, { reload: true });
                }, function(){
                    messageService.registerUpdateError('');
                    $state.go('currencyExchangeRates', null, { reload: true });
                });
        }
    }
})();
